import React from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import ToggleableValueTypeSelector from "../components/ToggleableValueTypeSelector";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import PanelLayout from "../components/PanelLayout";
import InputWithLabel from "../components/InputWithLabel";
import ContentWithTopLabel from "../components/ContentWithTopLabel";

class PValueRangePanel extends React.Component {
    constructor(props) {
        super(props);
        this.types = [
            {
                text: "Constant Value",
                xmlType: "constantValue"
            },
            /*{
                icon: "language",
                text: "Context Property",
                xmlType: "contextProperty"
            }
             */
        ];
        this.defaultMinValue = 0;
        this.defaultMaxValue = 1;
        this.state = {
            pValueRangeOptions: {
                isMinimumSelected: false,
                isMaximumSelected: false,
                maxType: "constantValue",
                maxValue: this.defaultMaxValue,
                minType: "constantValue",
                minValue: this.defaultMinValue,
                inputScoreDynamicPropertyName: this.hasOptions ? this.props.clickedNodeInfo.extras.options.pValueRangeOptions.inputScoreDynamicPropertyName : null,
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.updatePValueRangeOptions = this.updatePValueRangeOptions.bind(this);
    }

    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.pValueRangeOptions) {
            this.setState({pValueRangeOptions: this.props.clickedNodeInfo.extras.options.pValueRangeOptions}, () => {
                this.updatePValueRangeOptions();
            });
        } else {
            this.updatePValueRangeOptions();
        }

    }

    handleChange(property, value) {
        this.setState(prevState => ({
            pValueRangeOptions: {
                ...prevState.pValueRangeOptions,
                [property]: value
            }
        }), () => {
            this.updatePValueRangeOptions();
        });
    }



    updatePValueRangeOptions() {
        const pValueRangeOptions = this.state.pValueRangeOptions;
        const clickedNodeInfo = this.props.clickedNodeInfo;

        let pValueRangeInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(pValueRangeInfo.extras, "options")) {
            pValueRangeInfo.extras.options = {};
        }
        pValueRangeInfo.extras.options.pValueRangeOptions = pValueRangeOptions;
        this.props.clickedNodeAction(pValueRangeInfo);
    }

    render() {
        return (
            <PanelLayout>
                <ToggleableValueTypeSelector
                    label="Minimum"
                    nonSelectedLabel="No Minimum"
                    selectedType={this.state.pValueRangeOptions["minType"]}
                    selectedOption="minType"
                    value={this.state.pValueRangeOptions["minValue"]}
                    selectedValue="minValue"
                    handleChange={this.handleChange}
                    types={this.types}
                    isSelectorSelected={this.state.pValueRangeOptions.isMinimumSelected}
                    selectorProperty="isMinimumSelected"
                    defaultInputValue={this.defaultMinValue}
                />
                <ToggleableValueTypeSelector
                    label="Maximum"
                    nonSelectedLabel="No Maximum"
                    selectedType={this.state.pValueRangeOptions["maxType"]}
                    selectedOption="maxType"
                    value={this.state.pValueRangeOptions["maxValue"]}
                    selectedValue="maxValue"
                    handleChange={this.handleChange}
                    types={this.types}
                    isSelectorSelected={this.state.pValueRangeOptions.isMaximumSelected}
                    selectorProperty="isMaximumSelected"
                    defaultInputValue={this.defaultMaxValue}
                />

                <ContentWithTopLabel label="Input Score Name">
                    <InputWithLabel label="Input Score Dynamic Property Name:"
                                    handleChange={e => this.handleChange('inputScoreDynamicPropertyName', e.target.value)}
                                    value={this.state.pValueRangeOptions["inputScoreDynamicPropertyName"] ? this.state.pValueRangeOptions["inputScoreDynamicPropertyName"]: ""}
                    />
                </ContentWithTopLabel>
            </PanelLayout>

        )
    }
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}


export default connect(mapStateToProps, {clickedNodeAction, hideModal})(PValueRangePanel);
